import clsx from "clsx";
import { useLanguageContext } from "../../context/languageContext";
import { languageEN } from "./../../languageEN";
import { languagePL } from "./../../languagePL";
type Props = {
  type: "back" | "next" | "submit" | "homepage";
  onClick?: () => void;
  disabled?: boolean;
};
export const Button = ({ type, disabled, onClick }: Props) => {
  const returnButtonSubmit = () => {
    return language === "PL"
      ? languagePL.buttonSubmit
      : languageEN.buttonSubmit;
  };
  const returnButtonHomePage = () => {
    return language === "PL"
      ? languagePL.buttonHomePage
      : languageEN.buttonHomePage;
  };
  const { language, setLanguage } = useLanguageContext();
  
  return (
    <button
      className={clsx(
        type === "back" && "button_back",
        (type === "next" || type === "submit" || type === "homepage") &&
          "button_next"
      )}
      disabled={disabled}
      onClick={onClick}
    >
      {type === "back" && (
        <>
          <i className="arrow_left"></i>
          {language === "PL" ? languagePL.buttonBack : languageEN.buttonBack}
        </>
      )}
      {type === "next" && (
        <>
          {language === "PL"
            ? languagePL.buttonForward
            : languageEN.buttonForward}{" "}
          <i className="arrow_right"></i>
        </>
      )}
      {type === "submit" && returnButtonSubmit()}
      {type === "homepage" && returnButtonHomePage()}
    </button>
  );
};
